import   React                            ,
       { useState                         ,
         useEffect                        ,
         useRef                           }  from "react";

import   classNames                          from "classnames";

import   styles                              from "./BroadcastingChannelsList.module.scss";

import   AnimatedWaitingIcon                 from '../../../widget/animations/animatedWaitingIcon';
import   TabularDisplay                      from "../../../widget/dataDisplay/tables/TabularDisplay";
import   Icon                                from '../../../widget/images/Icon';

import { groupData                        ,
         GroupedData                      ,
		 initializedGroupedData           }  from "../../../../dataTypes/dataSetManagment/regroupData";

import { BroadcastingChannel              }  from '../../../../dataTypes/broadcastingManagment/types';

import { getBroadcastingChannelList       }  from '../../../../backendServices/broadcastingManagment/api_broadcastingChannel';
import { getHeartBeatCount                }  from '../../../../backendServices/customerFrontEventManagment/api';
		 

const BroadcastingChannelsList: React.FC = () => {

  const [ showWaitingIcon , setShowWaitingIcon ] = useState(true);
  const [ groupedData     , setGroupedData     ] = useState<GroupedData<BroadcastingChannel>>(initializedGroupedData<BroadcastingChannel>())

  const intervalRef    = useRef<NodeJS.Timeout | null>(null);

  const fetchData = async () => {

    try
     {
      setShowWaitingIcon (true);

      const getBroadcastingChannelListResult = await getBroadcastingChannelList (false)


      if (getBroadcastingChannelListResult.code === 1)
       {
        let tab = getBroadcastingChannelListResult.payload

        for (let num=0; num<tab.length; num++)
         {
         const getHeartBeatCountResult = await getHeartBeatCount( undefined     ,     // Pas de date
		                                                          tab[num].uuid , 
																  'live'        ,
																  '1 minute'    )   

          if ( getHeartBeatCountResult.code === 1 )
                {
                 tab[num].currentNumberOfConnections = getHeartBeatCountResult.payload.ipCount
                }
           else {
                 tab[num].currentNumberOfConnections = 0
                }
         }

        let groupKeyBroadcastingChannel = (broadcastingChannel: BroadcastingChannel) => ({
            key      : broadcastingChannel.name,
            renderer : (val: string) => val,
        })

        const groupedBroadcastingChannels = groupData<BroadcastingChannel> ( tab, groupKeyBroadcastingChannel );

        setShowWaitingIcon(false);
        setGroupedData (groupedBroadcastingChannels)
       }
     }
    catch (error)
     {
      console.error("Erreur lors de la récupération des sessions :", error);
      setShowWaitingIcon(false);
     }
  };

  useEffect(() => {

    fetchData(); 

    intervalRef.current = setInterval(fetchData, 60000); 

    return () => {
      if (intervalRef.current) 
	   {
        clearInterval(intervalRef.current); 
       }
    };
  }, []);

  const renderBroadcastingChannelsList = (): JSX.Element => {

    const columns = [
       {
         header       : 'Chaîne'                               ,
         accessor     : 'name' as keyof BroadcastingChannel ,
         width        : '150px'
       } ,
       {
         header       : 'Programme en cours'                                 ,
         accessor     : 'currentBroadcastedMediaName' as keyof BroadcastingChannel,
         cellRenderer : (value: string) => ( value === "" ? <span>-</span> : <span>{value}</span> ) ,
       } ,
       {
         header       : 'Cnx'                                                 ,
         accessor     : 'currentNumberOfConnections' as keyof BroadcastingChannel ,
         align        : 'center' as const,
         cellRenderer : (value: number) => ( <span>{value}</span> ) ,
       },
       {
         header       : 'URL'                ,
         accessor     : 'watchingUrl' as keyof BroadcastingChannel,
         cellRenderer : (value: string) => ( value === "" ? <span>-</span> : <span>{value}</span> ) ,
       },
       {
         header       : 'Mode'               ,
         accessor     : 'mode' as keyof BroadcastingChannel,
         align        : 'center' as const,
         cellRenderer : (value: string) => ( <span>{value === 'Delayed' ? 'Diffusion' : 'Direct'}</span> ) ,
       },
       {
         header       : 'Payant'           ,
         accessor     : 'secure' as keyof BroadcastingChannel  ,
         cellRenderer : (value: boolean) => ( <Icon name="disk" color={value?"var(--color-G)":"var(--color-R)"} width={20} height={16} hoverable={false} clickable={false}/> ) ,
         align        : 'center' as const
       },
       {
         header       : 'Public'               ,
         accessor     : 'publicPortal' as keyof BroadcastingChannel,
         align        : 'center' as const,
         cellRenderer : (value: boolean) => ( <Icon name="disk" color={value?"var(--color-G)":"var(--color-R)"} width={20} height={16} hoverable={false} clickable={false}/> ) ,
       },
       {
         header       : 'Actif'             ,
         accessor     : 'active' as keyof BroadcastingChannel  ,
         cellRenderer : (value: boolean) => ( <Icon name="disk" color={value?"var(--color-G)":"var(--color-R)"} width={20} height={16} hoverable={false} clickable={false}/> ) ,
         align        : 'center' as const
       },
    ];

    return (
              <>
                <div className={styles.wrapper}>
                  <div className={styles.container}>
                    <TabularDisplay groupedData           = {groupedData}
                                    columns               = {columns}
                                    defaultHighlightColor = "var(--color-Text-FG-emphasized)"
                                    showGroupHeaders      = {false} />
                  </div>
                </div>
              </>
           );
	
	return <></>
  }

  return (
    
      <div className={classNames(styles.root)}>

        <div className={classNames(styles.overlay)}>
		  {showWaitingIcon && <AnimatedWaitingIcon />}
        </div>
	  
        {renderBroadcastingChannelsList()}
		
      </div>

  );
};

export default BroadcastingChannelsList;
